import Page from "./Page";


class GenericPage extends Page {

    public override run() {
        super.run();
        this.onPageReady();
    }
}


new GenericPage().run();